import { render, staticRenderFns } from "./CatalisadoresPecasFormFotos.vue?vue&type=template&id=650f48f4&"
import script from "./CatalisadoresPecasFormFotos.vue?vue&type=script&lang=ts&"
export * from "./CatalisadoresPecasFormFotos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCol,VImg})
